// package: analyzer
// file: analyzer.proto

var analyzer_pb = require("./analyzer_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Analyzer = (function () {
  function Analyzer() {}
  Analyzer.serviceName = "analyzer.Analyzer";
  return Analyzer;
}());

Analyzer.DashboardOverview = {
  methodName: "DashboardOverview",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.DashboardOverviewReq,
  responseType: analyzer_pb.DashboardOverviewReply
};

Analyzer.GetPerformanceOverview = {
  methodName: "GetPerformanceOverview",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetPerformanceOverviewReq,
  responseType: analyzer_pb.PerformanceOverviewReply
};

Analyzer.GetPortfolioOverview = {
  methodName: "GetPortfolioOverview",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetPortfolioOverviewReq,
  responseType: analyzer_pb.GetPortfolioOverviewReply
};

Analyzer.GetPortfolioEquityCurve = {
  methodName: "GetPortfolioEquityCurve",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetPortfolioEquityCurveReq,
  responseType: analyzer_pb.PortfolioEquityCurve
};

Analyzer.GetPortfolioDailyAndCumulativeROI = {
  methodName: "GetPortfolioDailyAndCumulativeROI",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetPortfolioDailyAndCumulativeROIReq,
  responseType: analyzer_pb.DailyROIChart
};

Analyzer.ListAccounts = {
  methodName: "ListAccounts",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.ListAccountsReq,
  responseType: analyzer_pb.ListAccountsReply
};

Analyzer.ListAccountsLite = {
  methodName: "ListAccountsLite",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.ListAccountsLiteReq,
  responseType: analyzer_pb.ListAccountsLiteReply
};

Analyzer.GetAccountPerformance = {
  methodName: "GetAccountPerformance",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetAccountPerformanceRequest,
  responseType: analyzer_pb.GetAccountPerformanceResponse
};

Analyzer.GetAccountTradeList = {
  methodName: "GetAccountTradeList",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetAccountTradeListRequest,
  responseType: analyzer_pb.GetAccountTradeListResponse
};

Analyzer.GetAccountSettings = {
  methodName: "GetAccountSettings",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetAccountSettingsReq,
  responseType: analyzer_pb.GetAccountSettingsReply
};

Analyzer.UpdateAccountSettings = {
  methodName: "UpdateAccountSettings",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.UpdateAccountSettingsReq,
  responseType: analyzer_pb.UpdateAccountSettingsReply
};

Analyzer.GetUserTags = {
  methodName: "GetUserTags",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.GetUserTagsReq,
  responseType: analyzer_pb.GetUserTagsReply
};

Analyzer.CreateUserTag = {
  methodName: "CreateUserTag",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.CreateUserTagReq,
  responseType: analyzer_pb.CreateUserTagReply
};

Analyzer.DeleteUserTag = {
  methodName: "DeleteUserTag",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.DeleteUserTagReq,
  responseType: analyzer_pb.DeleteUserTagReply
};

Analyzer.SetTradeTag = {
  methodName: "SetTradeTag",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.SetTradeTagReq,
  responseType: analyzer_pb.SetTradeTagReply
};

Analyzer.UpdateUserTag = {
  methodName: "UpdateUserTag",
  service: Analyzer,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.UpdateUserTagReq,
  responseType: analyzer_pb.UpdateUserTagReply
};

exports.Analyzer = Analyzer;

function AnalyzerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AnalyzerClient.prototype.dashboardOverview = function dashboardOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.DashboardOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getPerformanceOverview = function getPerformanceOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetPerformanceOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getPortfolioOverview = function getPortfolioOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetPortfolioOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getPortfolioEquityCurve = function getPortfolioEquityCurve(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetPortfolioEquityCurve, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getPortfolioDailyAndCumulativeROI = function getPortfolioDailyAndCumulativeROI(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetPortfolioDailyAndCumulativeROI, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.listAccounts = function listAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.ListAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.listAccountsLite = function listAccountsLite(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.ListAccountsLite, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getAccountPerformance = function getAccountPerformance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetAccountPerformance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getAccountTradeList = function getAccountTradeList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetAccountTradeList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getAccountSettings = function getAccountSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetAccountSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.updateAccountSettings = function updateAccountSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.UpdateAccountSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.getUserTags = function getUserTags(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.GetUserTags, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.createUserTag = function createUserTag(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.CreateUserTag, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.deleteUserTag = function deleteUserTag(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.DeleteUserTag, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.setTradeTag = function setTradeTag(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.SetTradeTag, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyzerClient.prototype.updateUserTag = function updateUserTag(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Analyzer.UpdateUserTag, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AnalyzerClient = AnalyzerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "analyzer.Internal";
  return Internal;
}());

Internal.IntAddAccount = {
  methodName: "IntAddAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analyzer_pb.IntAddAccountReq,
  responseType: analyzer_pb.IntAddAccountReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intAddAccount = function intAddAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAddAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

